import { useContext, useEffect } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import UserContext from '~/context/common/UserContext';

export default function useTrackUserGeolocations() {
  const trackEvent = useTrackEvent();
  const {
    geolocationLogging: {
      merchLocationData = null,
      googleUtmLocationData = null
    } = {}
  } = useContext(UserContext);

  const shouldFire =
    Boolean(merchLocationData) && Boolean(googleUtmLocationData);

  useEffect(() => {
    if (!shouldFire) return;

    trackEvent('Geolocation Compare', {
      merchLocationData,
      googleUtmLocationData,
      originalLocationSource: merchLocationData?.source,
      wasSuccessful:
        googleUtmLocationData && googleUtmLocationData.accuracyRadius
          ? googleUtmLocationData.accuracyRadius === 0
          : false
    });
  }, [googleUtmLocationData, merchLocationData, shouldFire, trackEvent]);
}
